import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Modal, Button, Form, notification, Col, Row } from "antd";

import FloatInput from "../../../../providers/FloatInput";
import { POST, GET } from "../../../../providers/useAxiosQuery";
import validateRules from "../../../../providers/validateRules";
import FloatInputMask from "../../../../providers/FloatInputMask";
import FloatSelect from "../../../../providers/FloatSelect";

export default function ModalEditUniversity(props) {
	const { toggleModalEditUniversity, setToggleModalEditUniversity } = props;

	// console.log("course", course);
	// console.log("role", role);
	const [form] = Form.useForm();
	const params = useParams();

	const { mutate: mutateEmail, loading: loadingEmail } = POST(
		`api/ref_universities`,
		[`edit_university_${toggleModalEditUniversity.id}`]
	);

	const onFinish = (values) => {
		console.log("onFinish", values);

		let data = {
			...values,

			id:
				toggleModalEditUniversity &&
				toggleModalEditUniversity.data &&
				toggleModalEditUniversity.data.id,

			// book_id: toggleModalEditAuthor.book_id,
		};

		mutateEmail(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "University Updated",
						description: res.message,
					});

					setToggleModalEditUniversity({ open: false, data: null });

					form.resetFields();
				} else {
					notification.error({
						message: "Something went wrong",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notification.error({
					message: "University not successfully Updated",
					description: "Something went Wrong",
				});
			},
		});
	};

	useEffect(() => {
		if (toggleModalEditUniversity.open) {
			if (toggleModalEditUniversity.data) {
				let data = {
					...toggleModalEditUniversity.data,
					// email: toggleModalEditCourse.data.user.email,
				};
				form.setFieldsValue(data);
			}
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggleModalEditUniversity]);

	return (
		<Modal
			title="Edit Uiversity"
			open={toggleModalEditUniversity.open}
			onCancel={() => {
				setToggleModalEditUniversity({
					open: false,
					data: null,
				});
			}}
			footer={[
				<Button
					className="btn-main-primary outlined"
					size="large"
					key={1}
					onClick={() => {
						setToggleModalEditUniversity({
							open: false,
							data: null,
						});
						form.resetFields();
					}}
				>
					CANCEL
				</Button>,
				<Button
					className="btn-main-primary"
					type="primary"
					size="large"
					key={2}
					onClick={(values) => form.submit(values)}
					loading={loadingEmail}
				>
					SUBMIT
				</Button>,
			]}
		>
			<Form form={form} onFinish={onFinish}>
				<Form.Item name="university_name">
					<FloatInput label="University" placeholder="University" required />
				</Form.Item>
			</Form>
		</Modal>
	);
}
